import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './utils/filters';
import device from "vue-device-detector"
import imagePreloader from 'vue-image-preloader'
import vuescroll from 'vuescroll';
import checkView from 'vue-check-view'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import VueParallaxJs from 'vue-parallax-js'

Vue.use(checkView)
Vue.use(device)
Vue.config.productionTip = false
Vue.use(imagePreloader)
Vue.use(vuescroll)
Vue.use(VueParallaxJs)

Vue.use(VueAwesomeSwiper, {

})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
